import type React from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog"
import { Mail, Globe } from "lucide-react"

interface ContactUsPopupProps {
  isOpen: boolean
  onClose: () => void
}

const ContactUsPopup: React.FC<ContactUsPopupProps> = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Contact Us</DialogTitle>
          <DialogDescription>Get in touch with our team</DialogDescription>
        </DialogHeader>
        <div className="mt-4 space-y-6">
          <div className="space-y-4">
            <p className="text-sm">
              We're here to help! If you have any questions, feedback, or need assistance, please don't hesitate to
              reach out.
            </p>

            <div className="space-y-3">
              <div className="flex items-center gap-2 text-sm">
                <Mail className="h-4 w-4" />
                <a href="mailto:contact@coverage-maps.com" className="text-blue-600 hover:underline">
                  contact@coverage-maps.com
                </a>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Globe className="h-4 w-4" />
                <a href="https://coverage-maps.com" className="text-blue-600 hover:underline">
                  coverage-maps.com
                </a>
              </div>
            </div>

            <div className="mt-6">
              <h3 className="font-semibold mb-2">Response Time</h3>
              <p className="text-sm">
                We typically respond to all inquiries within 24-48 hours during business days. For urgent matters,
                please include "URGENT" in your email subject line.
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ContactUsPopup
